import {
  Field,
  FieldContent,
  FieldDescription,
  FieldLabel,
  FieldTitle,
} from "@volca/ui/components/ui/field";
import {
  RadioGroup,
  RadioGroupItem,
} from "@volca/ui/components/ui/radio-group";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import {
  AI_SCRIPT_RERUN_VERSION_CHOICE,
  type AiScriptRerunVersionChoice,
} from "./types";

interface RerunOptionCardProps {
  id: string;
  value: AiScriptRerunVersionChoice;
  title: string;
  description: string;
}

const RerunOptionCard = ({
  id,
  value,
  title,
  description,
}: RerunOptionCardProps) => (
  <FieldLabel htmlFor={id}>
    <Field orientation="horizontal">
      <RadioGroupItem value={value} id={id} />
      <FieldContent>
        <FieldTitle>{title}</FieldTitle>
        <FieldDescription>{description}</FieldDescription>
      </FieldContent>
    </Field>
  </FieldLabel>
);

interface RerunVersionSelectorProps {
  label: string;
  runVersion: number | null;
  currentVersion: number | null;
  choice: AiScriptRerunVersionChoice | null;
  onChange: (choice: AiScriptRerunVersionChoice) => void;
}

export const RerunVersionSelector = ({
  label,
  runVersion,
  currentVersion,
  choice,
  onChange,
}: RerunVersionSelectorProps) => {
  const idPrefix = `rerun-${label.toLowerCase()}-version`;

  return (
    <Stack className="w-full" align="start" gap={2}>
      <Text variant="label">{label} version</Text>
      <RadioGroup
        value={choice}
        onValueChange={(next) => onChange(next as AiScriptRerunVersionChoice)}
        aria-label={`Which ${label.toLowerCase()} version to run with`}
      >
        <RerunOptionCard
          id={`${idPrefix}-keep`}
          value={AI_SCRIPT_RERUN_VERSION_CHOICE.keep}
          title="Keep last run's"
          description={`v${runVersion}`}
        />
        <RerunOptionCard
          id={`${idPrefix}-latest`}
          value={AI_SCRIPT_RERUN_VERSION_CHOICE.latest}
          title="Use latest"
          description={`v${currentVersion}`}
        />
      </RadioGroup>
    </Stack>
  );
};

export const RerunVersionUnchanged = ({
  label,
  version,
}: {
  label: string;
  version: number;
}) => (
  <Text variant="caption" tone="muted">
    {label} v{version} · unchanged
  </Text>
);
